module.exports = __webpack_public_path__ + "assets/img/news (3).c866069c.png";